module.exports = __webpack_public_path__ + "img/expired.5ad9b41f.png";